import { render } from "./NeutralMessage.vue?vue&type=template&id=ada59432"
import script from "./NeutralMessage.vue?vue&type=script&lang=js"
export * from "./NeutralMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__